import { CrmType } from "@/types/crm-settings";
import Image from "next/image";

export const ImageBasedOnCrm = ({
  crmType,
  size,
  className,
}: {
  crmType?: CrmType;
  size?: number;
  className?: string;
}) => {
  switch (crmType) {
    case CrmType.WEALTHBOX:
      return (
        <Image
          src="/assets/wealthbox.png"
          alt="wealthbox"
          width={size || 16}
          height={size || 16}
          className={className}
        />
      );
    case CrmType.SALESFORCE:
    case CrmType.PARAGON_SALESFORCE:
    case CrmType.PARAGON_FSC:
      return (
        <Image
          src="/assets/salesforce.svg"
          alt="salesforce"
          width={size || 16}
          height={size || 16}
          className={className}
        />
      );
    case CrmType.PARAGON_PRACTIFI:
      return (
        <Image
          src="/assets/practifi-logo.png"
          alt="practifi"
          width={size || 16}
          height={size || 16}
          className={className}
        />
      );
    case CrmType.PARAGON_XLR8:
      return (
        <Image
          src="/assets/xlr8-logo.png"
          alt="xlr8"
          width={size || 16}
          height={size || 16}
          className={className}
        />
      );
    case CrmType.PARAGON_SS_C_BLACKDIAMONDELEMENTS:
      return (
        <Image
          src="/assets/ss&c-logo.png"
          alt="SS&C Black Diamond Elements"
          width={size || 16}
          height={size || 16}
          className={className}
        />
      );
    case CrmType.REDTAIL:
      return (
        <Image
          src="/assets/redtail-icon.png"
          alt="redtail"
          width={size || 16}
          height={size || 16}
          className={className}
        />
      );
    case CrmType.PARAGON_MICROSOFTDYNAMICS:
      return (
        <Image
          src="/assets/microsoft-dynamics.svg"
          alt="microsoft dynamics"
          width={size || 16}
          height={size || 16}
          className={className}
        />
      );
    case CrmType.PARAGON_ZOHO:
    case CrmType.PARAGON_CLOVEN:
      return (
        <Image
          src="/assets/zoho.svg"
          alt="zoho"
          width={size || 22}
          height={size || 22}
          className={className}
        />
      );
    case CrmType.PARAGON_MAXIMIZER:
      return (
        <Image
          src="/assets/maximizer.png"
          alt="maximizer"
          width={size || 16}
          height={size || 16}
          className={className}
        />
      );
    case CrmType.PARAGON_EQUISOFT:
      return (
        <Image
          src="/assets/equisoft-logo.svg"
          alt="equisoft"
          width={size || 16}
          height={size || 16}
          className={className}
        />
      );
    case CrmType.LAYLAH:
      return (
        <Image
          src="/assets/laylah-logo.svg"
          alt="laylah"
          width={size || 16}
          height={size || 16}
          className={className}
        />
      );
    default:
      return <></>;
  }
};
